import { render } from "./TheCobertura.vue?vue&type=template&id=2774a849"
import script from "./TheCobertura.vue?vue&type=script&lang=js"
export * from "./TheCobertura.vue?vue&type=script&lang=js"

import "./TheCobertura.vue?vue&type=style&index=0&id=2774a849&lang=scss"

import exportComponent from "/home/runner/work/topnetms/topnetms/apps/topnetms_site_v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__